import { GA4EventHandlers } from '../../hooks'
import { StudentEnrollmentValidation_ViewerFragment } from './__generated__/student-enrollment-validation.graphql'
import { SharedDataInterface } from './context'
import { Steps } from './enums'
import {
  AcademicData,
  DocumentPreview,
  EnrollmentError,
  EnrollmentSuccess,
  UploadInstructions,
  ValidatingEnrollment,
} from './steps'
import {
  StudentEnrollmentValidationCallback,
  StudentEnrollmentValidationEventData,
  StudentEnrollmentValidationTexts,
} from './types'

interface StepFuncProps {
  viewer: StudentEnrollmentValidation_ViewerFragment | null
  onClose?: () => void
  sharedData?: SharedDataInterface
  setSharedData?: (data: SharedDataInterface) => void
  eventData?: StudentEnrollmentValidationEventData
  stepsCallback?: StudentEnrollmentValidationCallback
  gA4EventHandlers?: GA4EventHandlers
  texts?: StudentEnrollmentValidationTexts
}

type StepFunc = (props: StepFuncProps) => React.ReactNode

export const FLOW_STEPS: Record<Steps, StepFunc> = {
  [Steps.ACADEMIC_DATA]: ({ gA4EventHandlers }) => (
    <AcademicData gA4EventHandlers={gA4EventHandlers} />
  ),
  [Steps.UPLOAD_INSTRUCTIONS]: ({ gA4EventHandlers }) => (
    <UploadInstructions gA4EventHandlers={gA4EventHandlers} />
  ),
  [Steps.DOCUMENT_PREVIEW]: () => <DocumentPreview />,
  [Steps.VALIDATING_ENROLLMENT]: ({ gA4EventHandlers }) => (
    <ValidatingEnrollment gA4EventHandlers={gA4EventHandlers} />
  ),
  [Steps.ENROLLMENT_ERROR]: ({ gA4EventHandlers }) => (
    <EnrollmentError gA4EventHandlers={gA4EventHandlers} />
  ),
  [Steps.ENROLLMENT_SUCCESS]: ({ onClose, gA4EventHandlers, stepsCallback }) => (
    <EnrollmentSuccess
      onClose={onClose}
      gA4EventHandlers={gA4EventHandlers}
      stepsCallback={stepsCallback}
    />
  ),
}
